"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentBlockquote_1 = __importDefault(require("./getCurrentBlockquote"));
exports.getCurrentBlockquote = getCurrentBlockquote_1.default;
var isSelectionInBlockquote_1 = __importDefault(require("./isSelectionInBlockquote"));
exports.isSelectionInBlockquote = isSelectionInBlockquote_1.default;
//# sourceMappingURL=index.js.map